import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Home from './pages/Home'
import AboutMe from './pages/AboutMe'
import Contact from './pages/Contact'
import Projects from './pages/Projects'

import { BrowserRouter, Switch, Route } from 'react-router-dom';

ReactDOM.render(
  // <React.StrictMode>
  //   <Home/>
  // </React.StrictMode>,

  <BrowserRouter>
    <Switch>
      <Route path='/' component={Home} exact/>
      <Route path='/aboutme' component={AboutMe}/>
      <Route path='/contact' component={Contact}/>
      <Route path='/projects' component={Projects}/>
      <Route component={Home}/>

    </Switch>
  </BrowserRouter>,
  document.getElementById('root')


);


